import { logGiftFlowEvent } from "./giftcard";

// Onboarding "for me / as a gift" answer (owner 2026-10-03: "how many wall buyers
// chose gift?" had no stored answer). Logged as an event right away, kept in
// localStorage and sent with the onboarding cart writes, so the cart (and the
// order made from it) carries it — see server/utils/onboardingChoice.js.
// The gift answer is sticky: it sends the shopper to /gift-card, and a later
// "self" on the way back must not erase that they asked for a gift.
const CHOICE_KEY = "onboardingChoice";
const GIFT_AT_KEY = "onboardingGiftAt";
const AB_KEY = "onboardingAb";
const AB_ARMS = ["gift_first", "name_first"];

// CRO A/B (2026-10-29): which onboarding screen goes first — the for-me/gift
// question (gift_first, the original order) or the name/email/phone form
// (name_first). 50/50, sticky per browser; storage blocked → the original order.
export const onboardingAbVariant = () => {
  try {
    let arm = localStorage.getItem(AB_KEY);
    if (!AB_ARMS.includes(arm)) {
      arm = AB_ARMS[Math.random() < 0.5 ? 0 : 1];
      localStorage.setItem(AB_KEY, arm);
    }
    return arm;
  } catch (e) {
    return "gift_first";
  }
};

export const recordOnboardingChoice = (choice, wall = false) => {
  try {
    localStorage.setItem(CHOICE_KEY, choice);
    if (choice === "gift" && !localStorage.getItem(GIFT_AT_KEY)) {
      localStorage.setItem(GIFT_AT_KEY, new Date().toISOString());
    }
  } catch (e) { /* storage blocked — the event below still lands */ }
  logGiftFlowEvent(`onboarding_${choice}`, { wall }, wall ? "wall" : "photos");
};

/** Fields for an /addtocart body; empty when the shopper never answered. */
export const onboardingCartFields = () => {
  try {
    const choice = localStorage.getItem(CHOICE_KEY);
    const giftAt = localStorage.getItem(GIFT_AT_KEY);
    const ab = localStorage.getItem(AB_KEY);
    return {
      ...(choice ? { onboardingChoice: choice } : {}),
      ...(giftAt ? { onboardingGiftAt: giftAt } : {}),
      ...(ab ? { onboardingAb: ab } : {}),
    };
  } catch (e) {
    return {};
  }
};
